export default (props, e) => {
	e.preventDefault();
	const triggerBtn = e.target;

	var getClosest = (elem, selector) => {

		if (!Element.prototype.matches) {
			Element.prototype.matches =
					Element.prototype.matchesSelector ||
					Element.prototype.mozMatchesSelector ||
					Element.prototype.msMatchesSelector ||
					Element.prototype.oMatchesSelector ||
					Element.prototype.webkitMatchesSelector ||
					function(s) {
						var matches = (this.document || this.ownerDocument).querySelectorAll(s),
								i = matches.length;
						while (--i >= 0 && matches.item(i) !== this) {}
						return i > -1;
					};
		}

		for ( ; elem && elem !== document; elem = elem.parentNode ) {
			if ( elem.matches( selector ) ) return elem;
		}
		return null;

	};

	getClosest(triggerBtn, '.content-accordion').classList.toggle('active');

};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/webActions/contentAccordionToggle.js